export enum PayingPartyType {
    AGENT_FEE = 'AF',
    CREDIT = 'CR',
    DEBIT = 'DR'
}
